import _extends from "@babel/runtime/helpers/extends";
import colors from './colors';
import typography from './typography';
import icons from './icons';
export var theme = _extends({
  breakpoints: ['769px', '1366px'],
  space: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40],
  radii: {
    none: 0,
    small: 2,
    medium: 4,
    large: 6,
    pill: 40,
    circle: 99999
  },
  colors: colors,
  shadows: {
    none: 'none',
    dark50: '0px 2px 8px rgba(0, 0, 0, 0.05)',
    dark100: '0px 2px 10px rgba(0, 0, 0, 0.1)',
    dark150: '0px 1px 6px rgba(0, 0, 0, 0.15)',
    dark200: '0px 2px 16px rgba(0, 0, 0, 0.20)',
    dark250: '0px 1px 4px rgba(0, 0, 0, 0.25)',
    dark300: '0px 0px 15px 0px rgba(21, 23, 26, 0.5)'
  }
}, typography, {
  icons: icons
});